import { Component, inject } from '@angular/core';
import { DevoAreaService } from '../../../devo-area.service';
import { DevoCommitmentsPageService } from '../../devo-commitments.page.service';

@Component({
	selector: 'devo-commitments-commitments-view-part',
	standalone: true,
	// imports: [CommitmentsGridPart],
	templateUrl: './devo-commitments-commitments-view.part.html',
})
export class DevoCommitmentsCommitmentsViewPart {

	private readonly areaService = inject(DevoAreaService);
	public readonly pageService = inject(DevoCommitmentsPageService);

	// public commitments = computed(() => {
	// 	const data = this.areaService.configurationData();
	// 	return data?.commitments ?? [];
	// });

}